import { render, staticRenderFns } from "./TwTooltipNew.vue?vue&type=template&id=ce5a36b2&scoped=true"
import script from "./TwTooltipNew.vue?vue&type=script&lang=js"
export * from "./TwTooltipNew.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TwTooltipNew.vue?vue&type=style&index=0&id=ce5a36b2&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ce5a36b2",
  null
  ,true
)

export default component.exports